import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="progsteps"
export default class extends Controller {
  connect() {
    const tick = '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="xicons"><path id="Vector" d="M20 6.5L9 17.5L4 12.5" stroke="#1B365C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></svg>';
    const dot = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="6" fill="#1B365C"/></svg>';
    const roundals = document.querySelectorAll('.signup-progress__roundal');

    roundals.forEach(roundal => {
      let status = roundal.innerText.replace(/ /g, '')
      if(status == 'checked'){
        roundal.classList.add('checked')
        roundal.innerHTML = tick;
      } else if(status == 'current'){
        roundal.classList.add('current')
        roundal.innerHTML = dot;
      } else if(status == 'future'){
        roundal.classList.add('future')
        roundal.innerHTML = dot;
      } 
    });


  }
}